import type {CSSProperties} from 'react';

export const RESERVED_SPACER_SIZE = 248;

export const TRUNCATION_WRAPPER_STYLES = {
  display: 'block',
  minWidth: '0',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const satisfies CSSProperties;

export const UNSET_TRUNCATION_WRAPPER_STYLES = {
  display: '',
  minWidth: '',
  overflow: '',
  textOverflow: '',
  whiteSpace: '',
} as const;
